import React, { Component } from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { Doughnut } from 'react-chartjs-2';
import { Card, CardBody, CardHeader } from 'reactstrap';
import LoadingOverlay from './LoadingOverlay';

const WELDS_BY_STATUS_QUERY = gql`
  query StatsWeldsByStatus {
    weldsByStatus: stats_welds_by_status {
      projectName: project_name
      status
      count
    }
  }
`;

const STATUS_COLORS = {
  'in_progress': 'rgba(54, 162, 235, 0.7)',
  'ready': 'rgba(75, 192, 192, 0.7)',
  'ok': 'rgba(75, 192, 75, 0.7)',
  'attachments_incomplete': 'rgba(255, 159, 64, 0.7)',
  'inconsistent': 'rgba(255, 206, 86, 0.7)',
  'removed': 'rgba(255, 99, 132, 0.7)'
};

class WeldsByStatusChart extends Component {
  render() {
    return (
      <Query query={WELDS_BY_STATUS_QUERY}>
        {({ loading, error, data }) => (
          <Card>
            <CardHeader>
              <strong>Welds by Status</strong>
            </CardHeader>
            <CardBody style={{ position: 'relative', minHeight: '200px' }}>
              {loading && <LoadingOverlay />}
              {error && <div>Error: {error.message}</div>}
              {!loading && !error && data && (() => {
                const stats = data.weldsByStatus;
          
          const projectGroups = stats.reduce((acc, item) => {
            if (!acc[item.projectName]) {
              acc[item.projectName] = [];
            }
            acc[item.projectName].push(item);
            return acc;
          }, {});

          const allStatuses = [...new Set(stats.map(s => s.status))];

                return (
                  <div>
                    {Object.keys(projectGroups).map((projectName, idx) => {
                  const projectData = projectGroups[projectName];
                  const totalWelds = projectData.reduce((sum, item) => sum + item.count, 0);
                  
                  const chartData = {
                    labels: projectData.map(d => d.status),
                    datasets: [{
                      data: projectData.map(d => d.count),
                      backgroundColor: projectData.map(d => STATUS_COLORS[d.status] || 'rgba(200, 200, 200, 0.7)')
                    }]
                  };

                  return (
                    <div key={idx} style={{ display: 'inline-block', width: '50%', verticalAlign: 'top' }}>
                      <div className="text-center mb-2">
                        <strong>{projectName} ({totalWelds} welds)</strong>
                      </div>
                      <div style={{ height: '150px' }}>
                        <Doughnut 
                          data={chartData} 
                          options={{ 
                            maintainAspectRatio: false,
                            legend: {
                              display: false
                            },
                            tooltips: {
                              callbacks: {
                                label: function(tooltipItem, data) {
                                  const label = data.labels[tooltipItem.index];
                                  const value = data.datasets[0].data[tooltipItem.index];
                                  return label + ': ' + value;
                                }
                              }
                            }
                          }} 
                        />
                      </div>
                    </div>
                  );
                    })}
                    <div className="text-center mt-3">
                      {allStatuses.map((status, idx) => (
                        <span key={idx} className="mr-3">
                          <span style={{
                            display: 'inline-block',
                            width: '12px',
                            height: '12px',
                            backgroundColor: STATUS_COLORS[status] || 'rgba(200, 200, 200, 0.7)',
                            marginRight: '5px'
                          }}></span>
                          {status}
                        </span>
                      ))}
                    </div>
                  </div>
                );
              })()}
            </CardBody>
          </Card>
        )}
      </Query>
    );
  }
}

export default WeldsByStatusChart;



// WEBPACK FOOTER //
// ./src/views/Dashboard/WeldsByStatusChart.js